import { render } from "./HausStep10.vue?vue&type=template&id=b2ebe0ec&scoped=true"
import script from "./HausStep10.vue?vue&type=script&lang=js"
export * from "./HausStep10.vue?vue&type=script&lang=js"

import "./HausStep10.vue?vue&type=style&index=0&id=b2ebe0ec&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ebe0ec"]])

export default __exports__